import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export function GuestRoute({ children }: { children: React.ReactNode }) {
  const { firebaseUser, appUser, loading, computeLandingRoute } = useAuth();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-muted-foreground">Cargando...</div>
      </div>
    );
  }

  if (firebaseUser && appUser) {
    return <Navigate to={computeLandingRoute(appUser)} replace />;
  }

  return <>{children}</>;
}
